import type { Provider } from '@/api/types'
import { AddToPlaylistSheet } from '@/components/selection/AddToPlaylistSheet'

export interface AddToPlaylistTarget {
  title: string
  provider: Provider
  externalId: string
  trackId: number | null
}
export interface AddToPlaylistDialogProps { target: AddToPlaylistTarget; onOpenChange: (open: boolean) => void }

export function AddToPlaylistDialog({ target, onOpenChange }: AddToPlaylistDialogProps) {
  return <AddToPlaylistSheet open onOpenChange={onOpenChange}
    trackIds={target.trackId != null ? [target.trackId] : undefined}
    providerRefs={target.trackId == null ? [{ provider: target.provider, external_id: target.externalId }] : undefined} />
}
